import React from "react";


import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";


export const ChevronRightIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue5cc'}</MuiIcon>
        );
    })
